var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{staticStyle:{"width":"0","height":"0"},attrs:{"type":"file","id":_vm.elId,"accept":"image/*"},on:{"change":_vm.imagePicked}}),_c('label',{staticClass:"v-btn primary ma-0",attrs:{"for":_vm.elId}},[_vm._v("Image")])])}
var staticRenderFns = []

export { render, staticRenderFns }